// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__HNbso","icon":"SortAdornment_icon__hIfcz","up":"SortAdornment_up__d7Noh","down":"SortAdornment_down__3AZcN","active":"SortAdornment_active__2kUvw"};